import React, { useEffect, useState } from "react";
import { _get } from "../services/service_api";
import {
  API_BASE_URL,
  APPOINTMENT_LIST,
  directToken,
  DOCTOR_LIST,
  LIST_OF_AREA,
  LIST_OF_HOSPITAL,
  LIST_OF_MASTER_SPECIALITY,
} from "../services/end_points";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import {
  Button,
  Card,
  Col,
  Popover,
  Row,
  Select,
  Table,
  Typography,
} from "antd";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
const ReportList = () => {
  const [appt, setAppt] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState([]);
  const [hospitalOption, setHospitalOption] = useState([]);
  const [areaOption, setAreaOption] = useState([]);
  const [FilteredSpecialities, setFilteredSpecialities] = useState([]);
  const [selectedSpecialityId, setSelectedSpecialityId] = useState(null);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [selectedHospitalId, setSelectedHospitalId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const userId = localStorage.getItem("userid");
  useEffect(() => {
    fetchData();
    doctorList();
    getHospital();
    getArea();
    getSPECIALITY();
  }, []);

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${APPOINTMENT_LIST}${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        setAppt(response.data.list);

        setFilteredAppointments(response.data.list);
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching appointments:", error.message);
    }
  };

  const getSPECIALITY = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${LIST_OF_MASTER_SPECIALITY}`,
        directToken
      );
      if (response.data && response.data.list) {
        const formattedData = response.data.list.map((speciality) => ({
          label: speciality.specialities_names,
          value: speciality.id,
        }));
        setFilteredSpecialities(formattedData);
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching specialities:", error.message);
    }
  };

  const filterAppointments = (
    appointments,
    doctorId,
    hospitalId,
    areaId,
    specialityId
  ) => {
    let filtered = appointments;

    if (doctorId) {
      filtered = filtered.filter(
        (appointment) => appointment.doctorId === doctorId
      );
    }

    if (hospitalId) {
      filtered = filtered.filter(
        (appointment) => appointment.hospitalId === hospitalId
      );
    }

    if (areaId) {
      filtered = filtered.filter((appointment) => appointment.area === areaId);
    }

    if (specialityId) {
      filtered = filtered.filter(
        (appointment) => appointment.doctorSpecialityId === specialityId
      );
    }
    // console.log("spe",filtered)
    return filtered;
  };

  const handleSpecialityChange = (value) => {
    setSelectedSpecialityId(value);
    setFilteredAppointments(
      filterAppointments(
        appt,
        selectedDoctorId,
        selectedHospitalId,
        selectedAreaId,
        value
      )
    );
  };

  const handleDoctorChange = (value) => {
    setSelectedDoctorId(value);
    setFilteredAppointments(
      filterAppointments(
        appt,
        value,
        selectedHospitalId,
        selectedAreaId,
        selectedSpecialityId
      )
    );
  };

  const handleHospitalChange = (value) => {
    setSelectedHospitalId(value);
    setFilteredAppointments(
      filterAppointments(
        appt,
        selectedDoctorId,
        value,
        selectedAreaId,
        selectedSpecialityId
      )
    );
  };

  const handleAreaChange = (value) => {
    setSelectedAreaId(value);
    setFilteredAppointments(
      filterAppointments(
        appt,
        selectedDoctorId,
        selectedHospitalId,
        value,
        selectedSpecialityId
      )
    );
  };

  const doctorList = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${DOCTOR_LIST}${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        const formattedData = response.data.list.map((source) => ({
          label: source.doctorsName,
          value: source.id,
        }));
        setSelectedDoctor(formattedData);
      } else {
        console.error("Error fetching the doctor list:", response.data);
      }
    } catch (error) {
      console.error("Error fetching the doctor list:", error);
    }
  };

  const getHospital = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        const formattedData = response.data.list.map((source) => ({
          label: source.hospitalName,
          value: source.id,
        }));
        setHospitalOption(formattedData);
      } else {
        console.error("Error fetching the hospital list:", response.data);
      }
    } catch (error) {
      console.error("Error fetching the hospital list:", error);
    }
  };

  const getArea = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_AREA}`,
        directToken
      );
      if (response.data && response.data.list) {
        const formattedData = response.data.list.map((source) => ({
          label: source.area,
          value: source.id,
        }));
        setAreaOption(formattedData);
      } else {
        console.error("Error fetching the area list:", response.data);
      }
    } catch (error) {
      console.error("Error fetching the area list:", error);
    }
  };

  const handleClear = () => {
    setSelectedDoctorId(null);
    setSelectedHospitalId(null);
    setSelectedAreaId(null);
    setSelectedSpecialityId(null);
    setFilteredAppointments(appt);
  };

  const dynamicData = filteredAppointments.map((dataItem, index) => ({
    key: index,
    serialNumber: index + 1,
    Name: dataItem.name,
    Email: dataItem.email,
    age: dataItem.age,
    Phone: dataItem.phone,
    Doctor: dataItem.doctorName,
    Speciality: dataItem.specialitiesName,
    city: dataItem.cityName,
    area: dataItem.areaName,
    hospital: dataItem.hospitalName,
    AppointmentDate: dataItem.date,
    slots: dataItem.time,
    Status: dataItem.status,
  }));

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNumber",
      key: "serialNumber",
    },
    {
      title: "Patient Name",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      key: "Phone",
    },
    {
      title: "Doctor",
      dataIndex: "Doctor",
      key: "Doctor",
    },
    {
      title: "Speciality",
      dataIndex: "Speciality",
      key: "Speciality",
    },
    {
      title: "Hospital Location",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Appointment Date",
      dataIndex: "AppointmentDate",
      key: "AppointmentDate",
    },
    {
      title: "Slot Time",
      dataIndex: "slots",
      key: "slots",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (status) => {
        let color = "";
        let background = "";
        let borderRadius = "";
        let width = "";
        let border = "";
        switch (status) {
          case "Confirmed":
            color = "#203dff";
            border = "1px solid #8e9bf6";
            background = "#c3c9f9bd";
            borderRadius = "30px";
            width = "85px";
            break;
          case "Cancelled":
            color = "#ff562f";
            border = "1px solid #ff070780";
            background = "#ffeae5";
            borderRadius = "30px";
            width = "85px";
            break;
          case "Rescheduled":
            color = "#00baff";
            width = "85px";
            border = "1px solid #00baff";
            // background="#d598e691";
            background = "#6fd6ef3d";
            borderRadius = "70px";
            break;
          case "Visited":
            color = "#05825f";
            border = "1px solid #05825f";
            background = "#8ce8ce73";
            borderRadius = "30px";
            width = "83px";
            break;
          default:
            color = "black";
        }
        return (
          <Button
            size="small"
            style={{ color, background, borderRadius, width, border }}
          >
            {status}
          </Button>
        );
      },
    },
  ];
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(dynamicData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
    XLSX.writeFile(workbook, "appointments.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Reports", 20, 10);

    doc.autoTable({
      head: [columns.map((col) => col.title)],
      body: dynamicData.map((row) => columns.map((col) => row[col.dataIndex])),
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 20 },
        2: { cellWidth: 20 },
        3: { cellWidth: 20 },
        4: { cellWidth: 20 },
        5: { cellWidth: 20 },
        6: { cellWidth: 20 },
        7: { cellWidth: 20 },
        8: { cellWidth: 20 },
        9: { cellWidth: 20 },
        10: { cellWidth: 20 },
      },
    });
    doc.save("appointments.pdf");
  };

  // Popover content for download options
  const downloadContent = (
    <div style={{ display: "flex", gap: "10px" }}>
      <Button
        onClick={exportToExcel}
        style={{ marginBottom: 10, color: "#1236fa" }}
        size="small"
      >
        Excel
      </Button>
      <Button onClick={exportToPDF} style={{ color: "#1236fa" }} size="small">
        PDF
      </Button>
    </div>
  );

  return (
    <DefaultLayout maxWidth="25rem">
      <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
        <Typography.Title level={4}>Reports</Typography.Title>
        <Row
          gutter={[16, 16]}
          align="middle"
          justify="space-between"
          style={{ marginBottom: "6px" }}
          wrap={true}
        >
          <Col xs={24} sm={12} md={8} lg={6} xl={2}>
            <Button onClick={handleClear}>
              <ReloadOutlined />
            </Button>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Select
              showSearch
              placeholder="Select Doctor"
              style={{ width: "100%", height: "35px" }}
              value={selectedDoctorId}
              options={selectedDoctor}
              onChange={handleDoctorChange}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Select
              showSearch
              placeholder="Select Hospital"
              style={{ width: "100%", height: "35px" }}
              value={selectedHospitalId}
              options={hospitalOption}
              onChange={handleHospitalChange}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Select
              showSearch
              placeholder="Hospital location"
              style={{ width: "100%", height: "35px" }}
              value={selectedAreaId}
              onChange={handleAreaChange}
              options={areaOption}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <Select
              showSearch
              placeholder="Select Speciality"
              style={{ width: "100%", height: "35px" }}
              options={FilteredSpecialities}
              onChange={handleSpecialityChange}
            />
          </Col>
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={6}
            xl={2}
            style={{ textAlign: "right" }}
          >
            {" "}
            <Popover
              content={downloadContent}
              title="Download Options"
              trigger="click"
            >
              <Button
                style={{ color: "black", border: "1.5px solid black" }}
                size="small"
              >
                {" "}
                <DownloadOutlined />
              </Button>
            </Popover>{" "}
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={dynamicData}
          pagination={{ pageSize: 8 }}
          style={{ marginTop: "3px" }}
          scroll={{ x: 1000 }}
        />
      </Card>
    </DefaultLayout>
  );
};

export default ReportList;
